(function () {
  'use strict';

  // Drives the donate block on the donate page and the compact prompt in the
  // cart. The preset path works without this script: the amount radios are named
  // "quantity", so a plain POST to /cart/add already carries the right amount.
  // What this adds is the custom amount, the live total, the readable line item
  // property and staying on the page.
  class SpikeyDonate extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type="submit"]');
      if (!this.form || !this.button) return;

      this.unit = parseInt(this.dataset.unit, 10) || 0;
      this.currency = this.dataset.currency || '$';
      this.after = this.dataset.after || 'stay';
      this.minQty = parseInt(this.dataset.minQty, 10) || 1;

      this.radios = Array.from(this.querySelectorAll('input[name="quantity"]'));
      this.customRadio = this.querySelector('[data-custom]');
      this.customWrap = this.querySelector('[data-donate-custom-wrap]');
      this.customInput = this.querySelector('[data-donate-custom-input]');
      this.property = this.querySelector('[data-donate-property]');
      this.totalOut = this.querySelector('[data-donate-total]');

      this.defaultLabel = this.button.textContent.trim();
      this.onChange = this.sync.bind(this);
      this.onSubmit = this.submit.bind(this);

      this.addEventListener('change', this.onChange);
      this.addEventListener('input', this.onChange);
      this.form.addEventListener('submit', this.onSubmit);
      this.sync();
    }

    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      if (this.resetTimer) clearTimeout(this.resetTimer);
    }

    get isCustom() {
      return !!(this.customRadio && this.customRadio.checked);
    }

    // Quantity is the unit of truth; the amount is derived from it. Rounding is
    // always down, so a value that does not divide evenly by the unit price
    // charges less than was typed rather than more.
    quantity() {
      if (this.isCustom) {
        var typed = parseFloat(String(this.customInput ? this.customInput.value : '').replace(/[^0-9.]/g, ''));
        if (!isFinite(typed) || typed <= 0 || !this.unit) return this.minQty;
        return Math.max(this.minQty, Math.floor(Math.round(typed * 100) / this.unit));
      }
      var checked = this.radios.filter(function (r) { return r.checked; })[0];
      return checked ? parseInt(checked.value, 10) || 1 : 1;
    }

    money(cents) {
      return this.currency + (cents / 100).toFixed(2);
    }

    sync() {
      if (this.customWrap) this.customWrap.hidden = !this.isCustom;

      var qty = this.quantity();
      var cents = qty * this.unit;

      // The custom radio carries the computed quantity, so the native form
      // submits correctly without any extra hidden field.
      if (this.isCustom && this.customRadio) this.customRadio.value = String(qty);

      if (this.property) this.property.value = this.money(cents);
      if (this.totalOut) {
        this.totalOut.textContent = this.unit ? this.money(cents) : '';
      }
    }

    submit(event) {
      if (typeof fetchConfig !== 'function' || typeof routes === 'undefined') return;

      event.preventDefault();
      if (this.button.getAttribute('aria-disabled') === 'true') return;

      this.sync();
      this.button.setAttribute('aria-disabled', 'true');
      this.label(this.button.dataset.addingLabel || 'Adding…');

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(this.form);
      formData.append('sections', 'cart-icon-bubble,cart-drawer');
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      var self = this;
      fetch(routes.cart_add_url, config)
        .then(function (response) { return response.json(); })
        .then(function (response) {
          if (response.status) {
            self.label(self.button.dataset.errorLabel || 'Try again');
            self.reset(2500);
            return;
          }
          if (self.after === 'reload') {
            window.location.reload();
            return;
          }
          if (self.after === 'checkout') {
            // /cart/checkout rather than /checkout, so a locale-prefixed
            // storefront keeps its prefix.
            window.location.href = routes.cart_url + '/checkout';
            return;
          }
          self.refresh(response.sections);
          self.label(self.button.dataset.addedLabel || 'Added');
          self.reset(2000);
          if (self.after === 'drawer') {
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') drawer.open();
          }
        })
        .catch(function () {
          self.label(self.button.dataset.errorLabel || 'Try again');
          self.reset(2500);
        });
    }

    label(text) {
      this.button.textContent = text;
    }

    reset(ms) {
      var self = this;
      if (this.resetTimer) clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(function () {
        self.label(self.defaultLabel);
        self.button.removeAttribute('aria-disabled');
      }, ms);
    }

    // Same contract as spikey-addon.js: the cart-drawer section is read and
    // written through #CartDrawer, not the <cart-drawer> element, and is-empty
    // is carried on two nodes.
    refresh(sections) {
      if (!sections) return;

      var bubbleHtml = sections['cart-icon-bubble'];
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubbleHtml && bubble) {
        var parsed = new DOMParser().parseFromString(bubbleHtml, 'text/html');
        var fresh = parsed.querySelector('.shopify-section');
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      }

      var drawerHtml = sections['cart-drawer'];
      var drawerInner = document.querySelector('#CartDrawer');
      if (drawerHtml && drawerInner) {
        var parsedDrawer = new DOMParser().parseFromString(drawerHtml, 'text/html');
        var freshDrawer = parsedDrawer.querySelector('#CartDrawer');
        if (freshDrawer) drawerInner.innerHTML = freshDrawer.innerHTML;
      }

      var drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.remove('is-empty');
      var inner = document.querySelector('cart-drawer .drawer__inner');
      if (inner) inner.classList.remove('is-empty');
    }
  }

  if (!customElements.get('spikey-donate')) {
    customElements.define('spikey-donate', SpikeyDonate);
  }
})();
